/* eslint-disable react-refresh/only-export-components */
/**
 * Workspace Routes
 *
 * Client-list and workspace-scoped routes.
 * Includes the canonical /w/:clientSlug/* path, the /clients/:clientSlug/*
 * compatibility redirect, and legacy /workspace/* redirects.
 */

import { lazy, Suspense } from "react";
import { Navigate, Route } from "react-router-dom";

import { AuthGate } from "@/components/access/AuthGate";
import { WorkspaceRedirect } from "@/components/WorkspaceRedirect";

// Client Routes (canonical client-scoped pages)
const ClientRoutes = lazy(() => import("@/pages/client/ClientRoutes"));

const PageLoader = () => (
  <div className="flex items-center justify-center p-8">
    <div className="text-gray-600">Loading...</div>
  </div>
);

export function workspaceRoutes() {
  return (
    <>
      {/* Client list now lives at / (canonical doorway). Redirect for compat. */}
      <Route path="clients" element={<Navigate to="/" replace />} />

      {/* =================================================================== */}
      {/* WORKSPACE ROUTES - Canonical workspace-scoped pages                 */}
      {/* /w/:clientSlug/* is the canonical path                              */}
      {/* /clients/:clientSlug/* redirects to /w/:clientSlug/* for compat     */}
      {/* =================================================================== */}

      {/* Canonical workspace routes: /w/:clientSlug/* */}
      <Route
        path="w/:clientSlug/*"
        element={
          <AuthGate>
            <Suspense fallback={<PageLoader />}>
              <ClientRoutes />
            </Suspense>
          </AuthGate>
        }
      />

      {/* Legacy redirect: /clients/:clientSlug/* → /w/:clientSlug/* */}
      <Route
        path="clients/:clientSlug/*"
        element={
          <AuthGate>
            <WorkspaceRedirect />
          </AuthGate>
        }
      />

      {/* =================================================================== */}
      {/* LEGACY REDIRECTS - /workspace/* always redirects                    */}
      {/* =================================================================== */}

      {/* /workspace → redirect to canonical workspace path */}
      <Route
        path="workspace"
        element={
          <AuthGate>
            <WorkspaceRedirect />
          </AuthGate>
        }
      />

      {/* /workspace/:clientSlug/* → redirect to canonical workspace path */}
      <Route
        path="workspace/:clientSlug/*"
        element={
          <AuthGate>
            <WorkspaceRedirect />
          </AuthGate>
        }
      />
    </>
  );
}
